/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import classname from "classnames";
import useForm from "../../../hooks/useForm";
import { get, isEmpty } from "lodash";
import { systemAlert } from "../../../utils/systemAlert";
import {
  postForgotPassword,
  postUsersCert,
  postUsersCertEmail,
  postUsersCertEmailVerify,
  postUsersCertVerify,
} from "../../../apis/users";
import { useHistory } from "react-router-dom";
import Button from "../../../components/Button";
import Timer from "../../../components/Timer";
import { Link } from "react-router-dom";
import { restoreMobile } from "../../../utils/validator/mobile";
import consultingPopup from "../../../utils/consulting";

const ForgetId = () => {
  const history = useHistory();
  const [tabMenus, setTabMenus] = useState([]);
  const [activeTab, setActiveTab] = useState("1");
  const [verifyToken, setVerifyToken] = useState("");
  const [isDisabled, setIsDisalbed] = useState({
    cert: false,
    verifyCode: true,
  });
  const [focus, setFocus] = useState({
    id: false,
    verifyCode: false,
    password: false,
  });
  const [isTimer, setIsTimer] = useState(false)
  const [isCertSuccess, setCertIsSuccess] = useState(false)

  useEffect(() => {
    setTabMenus([
      { label: "휴대폰 인증", value: "1" },
      { label: "이메일 인증", value: "2" },
    ]);
  }, []);

  const handleChangeTab = (tab) => {
    reset();
    setIsDisalbed({
      cert: false,
      verifyCode: true,
    });
    setActiveTab(get(tab, "value"));
  };

  const handleOnFocus = (e) => {
    const { name } = e.target;
    setFocus({
      ...focus,
      [name]: true,
    });
  };

  const handleOnBlur = (e) => {
    const { name } = e.target;
    setFocus({
      ...focus,
      [name]: false,
    });
  };
  const validate = ({ id, email, mobile, verifyCode, password }) => {
    let errors = {};
    const regEmail =
      /^[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[@]{1}[-A-Za-z0-9_]+[-A-Za-z0-9_.]*[.]{1}[A-Za-z]{1,5}$/;
    const regPwd = /^.*(?=^.{6,12}$)(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*()+=]).*$/;

    if (activeTab === "1") {
      if (!mobile) {
        errors.mobile = "휴대폰번호는 필수입니다.";
      }
    }

    if (activeTab === "2") {
      if (!email) {
        errors.email = "이메일은 필수입니다.";
      } else if (!regEmail.test(values.email)) {
        errors.email = "올바른 이메일 주소를 입력하세요.";
      }
    }
    if (!id) {
      errors.id = "아이디 필수입니다.";
    }
    
    if (!verifyToken) {
      errors.verifyCode = "인증확인 클릭해 주세요.";
    }

    if (!verifyCode) {
      errors.verifyCode = "인증번호는 필수입니다.";
    }

    if (!password) {
      errors.password = "비밀번호는 필수입니다.";
    } else if (!regPwd.test(values.password)) {
      errors.password = "영문자, 숫자, 특수문자 조합 6~12자로 설정해주세요";
    }

    return errors;
  };

  const submit = (values) => {
    if (!verifyToken) {
      systemAlert("휴대폰번호 혹은 이메일을 인증해주세요");
    }

    if (activeTab === "1") delete values.email;
    if (activeTab === "2") delete values.mobile;
    postForgotPassword({ ...values, verifyToken })
      .then(() => {
        systemAlert("비밀번호를 변경하였습니다. 다시 로그인해주세요.", {
          buttons: [{
            label: '확인',
            onClick: () => {

              setIsDisalbed({ cert: false, verifyCode: true });
              setVerifyToken("");
              reset();
              history.push("/");
            }
          }]
        });
        setCertIsSuccess(false)
      })
      .catch((err) => {
        // debugger
        systemAlert(get(err, "response.data.message", "시스템 에러"));
      });
  };

  const {
    values,
    errors,
    handleOnChange,
    handleSubmit,
    reset,
    setValidateFields
  } = useForm(
    {
      id: "",
      mobile: "",
      email: "",
      verifyCode: "",
      password: "",
    },
    submit,
    validate
  );

  useEffect(() => {
    setValidateFields([
      { key: 'id', type: 'inpyut' },
      { key: 'email', type: 'inpyut', validators: ['email'] },
      { key: 'mobile', type: 'inpyut', validators: ['mobile'] },
      { key: 'verifyCode', type: 'inpyut' },
      { key: 'password', type: 'inpyut' },
    ])
  }, []);

  useEffect(() => {
    setIsTimer(false)
    setCertIsSuccess(false)

    if (activeTab === "1") {
      setValidateFields([
        { key: 'id', type: 'inpyut' },
        { key: 'mobile', type: 'inpyut', validators: ['mobile'] },
        { key: 'verifyCode', type: 'inpyut' },
        { key: 'password', type: 'inpyut' },
      ])
    }

    if (activeTab === "2") {
      setValidateFields([
        { key: 'id', type: 'inpyut' },
        { key: 'email', type: 'inpyut', validators: ['email'] },
        { key: 'verifyCode', type: 'inpyut' },
        { key: 'password', type: 'inpyut' },
      ])
    }
  }, [activeTab])

  const handleOnClickCert = (e) => {
    e.preventDefault();
    if (activeTab === "1") {
      if (!values.mobile) return;
      postUsersCert({ mobile: restoreMobile(values.mobile) })
        .then(() => {
          setIsTimer(true)
          setIsDisalbed({ cert: true, verifyCode: false });
        })
        .catch((err) => {
          systemAlert(get(err, "response.data.message"));
        });
    }

    if (activeTab === "2") {
      postUsersCertEmail({ email: values.email })
        .then(() => {
          setIsTimer(true)
          setIsDisalbed({ cert: true, verifyCode: false });
        })
        .catch((err) => {
          systemAlert(get(err, "response.data.message"));
        });
    }
  };

  const handleOnclickVerify = (e) => {
    e.preventDefault();
    if (activeTab === "1") {
      postUsersCertVerify({
        mobile: restoreMobile(values.mobile),
        verifyCode: values.verifyCode,
      })
        .then((res) => {
          setVerifyToken(get(res, "data.verifyToken"));
          setIsDisalbed({ cert: true, verifyCode: true });
          setCertIsSuccess(true)
          setIsTimer(false)
          systemAlert("인증 성공하였습니다.");
        })
        .catch((err) => {
          setIsDisalbed({ cert: false, verifyCode: true });
          systemAlert(get(err, "response.data.message"));
        });
    }

    if (activeTab === "2") {
      postUsersCertEmailVerify({
        email: values.email,
        verifyCode: values.verifyCode,
      })
        .then((res) => {
          setVerifyToken(get(res, "data.verifyToken"));
          setIsDisalbed({ cert: true, verifyCode: true });
          setCertIsSuccess(true)
          setIsTimer(false)
          systemAlert("인증 성공하였습니다.");
        })
        .catch((err) => {
          systemAlert(get(err, "response.data.message"));
        });
    }
  };

  const timerExpiredAction = () => {
    setIsTimer(false)
    setIsDisalbed({
      verifyCode: true,
      cert: false
    })
  }

  return (
    <div className="Layout auth-wrap">
      <div className="Forget">
        <h1>비밀번호 찾기</h1>
        <div className="tab-wrap">
          {tabMenus.map((tab, index) => (
            <button
              key={index}
              className={classname("tab", {
                active: get(tab, "value") === activeTab,
              })}
              onClick={() => handleChangeTab(tab)}
            >
              {get(tab, "label")}
            </button>
          ))}
        </div>
        {activeTab === "1" && (
          <form onSubmit={handleSubmit}>
            <div className="form-wrap">
              <div
                className={classname("input-wrap", { focus: get(focus, "id") })}
              >
                <div>
                  <label>아이디</label>
                  <input
                    name="id"
                    placeholder="아이디를 입력해주세요"
                    value={values.id}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                  />
                  {errors.id && <p className="error-msg">{errors.id}</p>}
                </div>
              </div>
              <div className="divider" />
              <div
                className={classname("input-wrap", {
                  focus: get(focus, "mobile") || get(focus, "verifyCode"),
                })}
              >
                <div>
                  <label>휴대폰번호</label>
                  <input
                    name="mobile"
                    placeholder="휴대폰번호를 입력해주세요"
                    value={values.mobile}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    disabled={isDisabled.cert}
                  />
                  {errors.mobile && (
                    <p className="error-msg">{errors.mobile}</p>
                  )}
                  <Button
                    label="번호인증"
                    color="line"
                    size="sm"
                    className="send-cert-btn"
                    onClick={handleOnClickCert}
                    disabled={isEmpty(values.mobile) || isDisabled.cert}
                  />
                  {isTimer &&
                    <Timer isSuccess={isCertSuccess} expireAction={timerExpiredAction} />
                  }
                </div>
                <div>
                  <label></label>
                  <input
                    style={{ borderTop: "1px solid #F1F3F5" }}
                    name="verifyCode"
                    placeholder="인증번호를 입력해주세요"
                    value={values.verifyCode}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    disabled={isDisabled.verifyCode}
                  />
                  {isCertSuccess && (
                    <p className="cert-success-text">인증되었습니다</p>
                  )}
                  {errors.verifyCode && (
                    <p className="error-msg">{errors.verifyCode}</p>
                  )}
                  <Button
                    label="인증확인"
                    color="line"
                    size="sm"
                    className="send-cert-btn"
                    onClick={handleOnclickVerify}
                    disabled={isEmpty(values.verifyCode) || isDisabled.verifyCode}
                  />
                </div>
              </div>
              <div className="divider" />
              <div
                className={classname("input-wrap", {
                  focus: get(focus, "password"),
                })}
              >
                <div>
                  <label>비밀번호</label>
                  <input
                    name="password"
                    type="password"
                    placeholder="새로운 비밀번호를 입력해주세요"
                    value={values.password}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                  />
                  {errors.password && (
                    <p className="error-msg">{errors.password}</p>
                  )}
                </div>
              </div>
            </div>
            <Button
              size={'lg'}
              onClick={handleSubmit}
              className="w-full mt-24"
            >
              비밀번호 변경
            </Button>
          </form>
        )}
        {activeTab === "2" && (
          <form onSubmit={handleSubmit}>
            <div className="form-wrap">
              <div
                className={classname("input-wrap", {
                  focus: get(focus, "name"),
                })}
              >
                <div>
                  <label>아이디</label>
                  <input
                    name="id"
                    placeholder="아이디를 입력해주세요"
                    value={values.id}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                  />
                  {errors.id && <p className="error-msg">{errors.id}</p>}
                </div>
              </div>
              <div className="divider" />
              <div
                className={classname("input-wrap", {
                  focus: get(focus, "email") || get(focus, "verifyCode"),
                })}
              >
                <div>
                  <label>이메일</label>
                  <input
                    name="email"
                    placeholder="이메일을 입력해주세요"
                    value={values.email}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    disabled={isDisabled.cert}
                  />
                  {errors.email && <p className="error-msg">{errors.email}</p>}
                  <Button
                    label="메일인증"
                    color="line"
                    size="sm"
                    className="send-cert-btn"
                    onClick={handleOnClickCert}
                    disabled={isEmpty(values.email) || isDisabled.cert}
                  />
                  {isTimer &&
                    <Timer isSuccess={isCertSuccess} expireAction={timerExpiredAction} />
                  }
                </div>
                <div>
                  <label></label>
                  <input
                    style={{ borderTop: "1px solid #F1F3F5" }}
                    name="verifyCode"
                    placeholder="인증번호를 입력해주세요"
                    value={values.verifyCode}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                    disabled={isDisabled.verifyCode}
                  />
                  {isCertSuccess && (
                    <p className="cert-success-text">인증되었습니다</p>
                  )}
                  {errors.verifyCode && (
                    <p className="error-msg">{errors.verifyCode}</p>
                  )}
                  <Button
                    label="인증확인"
                    color="line"
                    size="sm"
                    className="send-cert-btn"
                    onClick={handleOnclickVerify}
                    disabled={isEmpty(values.verifyCode) || isDisabled.verifyCode}
                  />
                </div>
              </div>
              <div className="divider" />
              <div
                className={classname("input-wrap", {
                  focus: get(focus, "password"),
                })}
              >
                <div>
                  <label>비밀번호</label>
                  <input
                    name="password"
                    type="password"
                    placeholder="새로운 비밀번호를 입력해주세요"
                    value={values.password}
                    onChange={handleOnChange}
                    onFocus={handleOnFocus}
                    onBlur={handleOnBlur}
                  />
                  {errors.password && (
                    <p className="error-msg">{errors.password}</p>
                  )}
                </div>
              </div>
            </div>
            <Button
              size={'lg'}
              onClick={handleSubmit}
              className="w-full mt-24"
            >
              비밀번호 변경
            </Button>
          </form>
        )}
        <div className="forget-footer-text-wrap left">
          <span>도움이 필요하신가요?</span>
          <button className="forget-pwd-action">
            <span
              className="cursor-pointer"
              onClick={() => {
                consultingPopup(true)
              }}
            >WeCake에 문의하기</span>
          </button>
        </div>
        <div className="forget-footer-text-wrap right">
          <div className="login-button-wrap">
            <Link to="/login">로그인</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetId;
